export const account = {
  backLink: 'Back',
  logout: 'Log out',
  title: 'Password & security',
  name: {
    label: 'Name',
    placeholder: 'Enter name',
    submit: 'Save changes',
    tooltip: {
      title: 'Your name should:',
      text: "Be at least 3 characters and no more than 30; Contains only letters, numbers, spaces, hyphens, or underscores.; Doesn't consist of spaces only",
    },
  },
  userSuccess: 'User data has been successfully updated',
  email: {
    label: 'Email',
    placeholder: 'Enter email',
  },
  password: {
    label: 'Password',
    placeholder: 'Enter password',
    submit: 'Update password',
  },
  passwordNew: {
    placeholder: 'Enter new password',
    tooltip: {
      title: 'Your password must contain:',
      text: 'At least 5 characters; Letters (A-z); Numbers (0-9)',
    },
  },
  passwordSuccess: 'Password has been successfully changed',
  warning: {
    title: 'Danger zone',
    text: 'Once you delete your account, there is no going back.',
  },
  delete: 'Delete account',
  deleteConfirm: {
    title: 'delete account',
    description:
      'Please, confirm your account deleting\nwith your current password.',
    password: {
      placeholder: 'Password',
    },
    submit: 'confirm',
  },
  deleteSuccess: 'Account has been successfully deleted',
  profile: {
    saveChanges: 'Save changes',
    nickname: {
      label: 'Nickname',
      placeholder: 'Enter nickname',
    },
    password: {
      current: {
        label: 'Current password',
        placeholder: 'Enter current password',
      },
      new: {
        label: 'New password',
      },
      repeat: {
        label: 'Repeat password',
        placeholder: 'Repeat new password',
      },
    },
    mfa: {
      title: 'Two-factor authentication',
      enabled: 'Enabled',
      disabled: 'Disabled',
      description:
        'When enabled, you will be asked for a code from Google Authenticator during login.',
      enable: 'Enable 2FA',
      disable: 'Disable 2FA',
      disableModal: {
        title: 'Disable 2FA',
        confirmTitle: 'Confirm disable',
        hint: 'Enter the code from your authenticator to disable 2FA.',
        placeholder: 'Authenticator code',
        submit: 'Disable',
      },
      enableModal: {
        title: 'Enable 2FA',
        checkEmail: 'Check your email',
        hint: 'We sent a QR code and secret key to your email. Scan it with Google Authenticator (or use the fallback setup link), then enter the code below.',
        placeholder: 'Authenticator code',
        submit: 'Enable',
      },
      toast: {
        disabled: '2FA disabled',
        invalidCode: 'Invalid code',
        enabled: '2FA enabled',
        setupEmailSent: 'Check your email for the QR code',
        setupFailed: 'Unable to start 2FA setup',
      },
    },
    kyc: {
      title: 'Identity Verification (KYC)',
      description: 'Verify your identity to enable withdrawals.',
      start: 'Start KYC',
      continue: 'Continue KYC',
      refresh: 'Refresh status',
      status: {
        verified: 'Verified',
        pending: 'Verification in progress',
        actionRequired: 'Action required',
        notVerified: 'Not verified',
      },
    },
  },
  dob: {
    title: 'Date of birth',
    intro: 'Add your date of birth to continue.',
    description:
      'Choose your date of birth from the dropdowns below. You will return to your previous page after saving.',
    label: 'Date of birth',
    day: 'Day',
    month: 'Month',
    year: 'Year',
    submit: 'Save date of birth',
    incomplete: 'Select day, month, and year',
    saveFailed: 'Unable to save date of birth',
    months: {
      '01': 'January',
      '02': 'February',
      '03': 'March',
      '04': 'April',
      '05': 'May',
      '06': 'June',
      '07': 'July',
      '08': 'August',
      '09': 'September',
      '10': 'October',
      '11': 'November',
      '12': 'December',
    },
  },
  history: {
    title: 'Game history',
    headers: {
      date: 'Date',
      game: 'Game',
      entryFee: 'Entry fee',
      prize: 'Prize',
      result: 'Result',
    },
    result: {
      win: 'Win',
      lose: 'Lose',
      draw: 'Draw',
    },
    unknownGame: 'Unknown',
    empty: 'No matches found',
  },
  achievements: {
    title: 'Achievements',
    locked: 'Locked',
    earned: 'Earned: {{date}}',
    empty: 'No achievements yet',
    items: {
      'first-win': {
        name: 'First Win',
        description: 'Win your first game',
      },
      'quick-win': {
        name: 'Quick Win',
        description: 'Win a game within 60 seconds',
      },
      'one-on-one-win': {
        name: 'One-on-One Winner',
        description: 'Win a 1v1 match',
      },
      'login-streak-30': {
        name: '30 Day Streak',
        description: 'Log in 30 days in a row',
      },
      'login-streak-60': {
        name: '60 Day Streak',
        description: 'Log in 60 days in a row',
      },
    },
  },
};
